var map = {
	"./connect-store-reward.svg": 70719,
	"./create-athletic-crop-top-reward.svg": 74513,
	"./create-baby-youth-leggings-reward.svg": 7943,
	"./create-beanie-reward.svg": 52722,
	"./create-book-reward.svg": 65791,
	"./create-canvas-reward.svg": 81114,
	"./create-coaster-reward.svg": 71171,
	"./create-crewneck-sweatshirt-reward.svg": 45307,
	"./create-day-tote-reward.svg": 23829,
	"./create-desk-mat-reward.svg": 60288,
	"./create-drawstring-bag-reward.svg": 31602,
	"./create-dress-reward.svg": 81545,
	"./create-duvet-cover-reward.svg": 58698,
	"./create-fabric-reward.svg": 59659,
	"./create-fitted-polo-shirt-reward.svg": 5256,
	"./create-headband-reward.svg": 77315,
	"./create-kimono-reward.svg": 49845,
	"./create-leggings-reward.svg": 11234,
	"./create-makeup-bag-reward.svg": 89518,
	"./create-men-underwear-reward.svg": 89202,
	"./create-origami-tote-reward.svg": 3909,
	"./create-permanent-sticker-reward.svg": 45878,
	"./create-pillow-case-reward.svg": 40174,
	"./create-placemat-reward.svg": 63557,
	"./create-racerback-tank-top-reward.svg": 32485,
	"./create-scarf-reward.svg": 29451,
	"./create-scarf-reward_inactive.svg": 63865,
	"./create-shirt-bellacanvas-3001-reward.svg": 13914,
	"./create-shirt-bellacanvas-3001-reward_inactive.svg": 71738,
	"./create-shorts-reward.svg": 93673,
	"./create-skirt-reward.svg": 60497,
	"./create-stainless-steel-tumbler-reward.svg": 80258,
	"./create-stainless-steel-water-bottle-reward.svg": 83221,
	"./create-stationery-card-reward.svg": 57849,
	"./create-tank-top-reward.svg": 47088,
	"./create-tote-bag-reward.svg": 57927,
	"./create-unisex-joggers-reward.svg": 58022,
	"./create-unisex-polo-shirt-reward.svg": 40034,
	"./create-vegan-leather-backpack-reward.svg": 90180,
	"./create-vegan-leather-crossbody-purse-reward.svg": 73496,
	"./create-vegan-leather-makeup-bag-reward.svg": 33602,
	"./create-vegan-leather-tote-bag-reward.svg": 83507,
	"./create-wall-tapestry-reward.svg": 2747,
	"./create-women-underwear-reward.svg": 57788,
	"./create-wrap-skirt-reward.svg": 56768,
	"./create-yoga-shorts-reward.svg": 62197,
	"./create-zipper-carry-all-reward.svg": 12080,
	"./sell-product-one-reward.svg": 56752,
	"./sell-product-ten-reward.svg": 75343,
	"./setup-payment-reward.svg": 91967,
	"./sync-product-one-reward.svg": 33379,
	"./sync-product-ten-reward.svg": 86644,
	"./thank-you-2020-bronze.svg": 88615,
	"./thank-you-2020-diamond.svg": 26593,
	"./thank-you-2020-gold.svg": 94497,
	"./thank-you-2020-silver.svg": 19736,
	"./thank-you-2023-bronze.svg": 24370,
	"./thank-you-2023-diamond.svg": 38238,
	"./thank-you-2023-gold.svg": 29916,
	"./thank-you-2023-silver.svg": 95769,
	"./thank-you-2024-bronze.svg": 95835,
	"./thank-you-2024-diamond.svg": 89437,
	"./thank-you-2024-gold.svg": 48413,
	"./thank-you-2024-silver.svg": 79532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83171;